export const QM_CLIENT_NOTIFICATION_TYPE="QM_NOTIFICATION";export const QM_CLIENT_NOTIFICATION_SUBTYPES={INSIGHTS_READY:"INSIGHTS_READY"};